<ul>
  <li [ngClass]="{'fail': fail}">
    <div class="feedback-line">
      <ng-content></ng-content>
      <mat-icon *ngIf="!fail">check_circle</mat-icon>
    </div>
  </li>
</ul>
